import * as React from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import './cn-radio.scss';
const getInitCheckedStatus = (props) => {
    if ('checked' in props) {
        return props.checked;
    }
    else if (props.defaultChecked) {
        return props.defaultChecked;
    }
};
export const CnRadio = (props) => {
    const { size = 'medium', children, checked, onChange, disabled, className, defaultChecked, readOnly, onClick, ...others } = props;
    const prefix = 'cn-ui-m-';
    const [selected, setSelected] = React.useState(getInitCheckedStatus(props));
    const selectedPrefix = selected ? '--selected' : '--unselected';
    const disabledPrefix = disabled ? '-disabled' : '';
    const circleCls = classNames([
        `${prefix}radio-circle`,
        `${prefix}radio-circle--${size}`,
        `${prefix}radio-circle${selectedPrefix}${disabledPrefix}`,
    ]);
    const pointCls = classNames([
        `${prefix}radio-point`,
        `${prefix}radio-point--${size}`,
        `${prefix}radio-point${selectedPrefix}${disabledPrefix}`,
    ]);
    const textCls = classNames([
        `${prefix}radio-text`,
        `${prefix}radio-text--${size}`,
        `${prefix}radio-text${selectedPrefix}${disabledPrefix}`,
    ]);
    React.useEffect(() => {
        if ('checked' in props) {
            setSelected(props.checked);
        }
    });
    const handleClick = (e) => {
        if (!disabled && !readOnly) {
            if (isFunction(onChange)) {
                onChange(!selected, e);
            }
            if (isFunction(onClick)) {
                onClick(e);
            }
            // 非受控模式
            if (!('checked' in props)) {
                setSelected(!selected);
            }
        }
    };
    let text = null;
    if (children) {
        text =
            isString(children) || isNumber(children) ? (React.createElement("span", { className: textCls }, children)) : (React.createElement("div", { className: textCls }, children));
    }
    return (React.createElement("div", { ...others, className: classNames(`${prefix}radio-container`, `${prefix}radio-container--${size}`, className), onClick: handleClick },
        React.createElement("div", { className: circleCls },
            React.createElement("div", { className: pointCls })),
        text));
};
CnRadio.displayName = 'CnRadio';
CnRadio.defaultProps = {
    size: 'medium',
};
